import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import App from './App.tsx';
import './index.css';
import './styles/animations.css';
import { tokenState } from './auth/tokenState';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        // Don't retry on auth errors
        const status = (error as any)?.status;
        const errorDetail = (error as any)?.response?.data?.detail || (error as any)?.data?.detail;
        const isInvalidToken = errorDetail === "Invalid token." || errorDetail === "Invalid token";
        
        if (status === 401 || isInvalidToken) {
          return false;
        }
        
        // Retry once for other errors
        return failureCount < 1;
      },
    },
    mutations: {
      retry: false,
      onError: (error) => {
        // Handle auth errors globally for mutations
        const errorResponse = (error as any)?.response;
        const errorDetail = errorResponse?.data?.detail;
        
        if (
          errorResponse?.status === 401 || 
          errorDetail === "Invalid token." || 
          errorDetail === "Invalid token"
        ) {
          tokenState.clearTokens();
          window.location.href = '/login';
        }
      },
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
